import React from 'react';

import { DetailsList, DetailsListItem } from '@eika/details-list';

import type { AccountInterest, Currency } from '../../../generated-types';
import useTranslation from '../../../hooks/useTranslation';
import { InterestType } from '../../../translations/translationType';
import { currencyFormatter } from '../../shared/numberFormat';
import InterestList from './InterestList';

import './AccountInterestDetails.scss';

interface Props {
    interests?: AccountInterest;
    currency: Currency;
    isLoading: boolean;
}

const AccountInterestDetails: React.FC<Props> = ({ interests, currency, isLoading }) => {
    const translated = useTranslation();
    return (
        <DetailsList
            title={translated.accountInterest.header}
            className="account-interest-details"
            titleClassName="account-interest-details__title"
            isLoading={isLoading}
        >
            <InterestList interests={interests?.interestRates} type={InterestType.DEBIT} />
            <InterestList interests={interests?.debitInterestRates} type={InterestType.CREDIT} />
            <DetailsListItem
                label={translated.accountInterest.overdraftInterest}
                value={`${interests?.overdraftInterestRate} %`}
                show={!!interests?.overdraftInterestRate}
            />
            <DetailsListItem
                label={translated.accountInterest.grantedOverdraftInterest}
                value={`${interests?.grantedOverdraftInterestRate} %`}
                show={!!interests?.grantedOverdraftInterestRate}
            />
            <DetailsListItem
                label={translated.accountInterest.notYetCapitalizedInterest}
                value={currencyFormatter(interests?.notYetCapitalizedInterest, currency)}
                show={!!interests?.notYetCapitalizedInterest}
            />
        </DetailsList>
    );
};

export default AccountInterestDetails;
